<template>
  <div class="drug-detail contant-wrap">
   <div class="filter-data">
      <h3>欠费管理</h3>
      <div class="filter-control">
        <el-row :gutter="40">
          <el-col :span="8">
            <div class="rows">
              <div class="fix-wrap">
                <label for="">就诊日期：</label>
                <el-date-picker
                  class="container"
                  v-model="time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                  @change="filterChange">
                </el-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows">
              <div class="fix-wrap">
                <el-input class="container" placeholder="姓名/电话号码" v-model="query.patient">
                  <el-button slot="append" icon="el-icon-search" @click="filterChange"></el-button>
                </el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows rows-last">
              <el-button type="primary" class="button" @click="mergePay">合并付款</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="flex-div">
      <div class="box1">
        <div class="fz-28">{{patientNum}}</div>
        <div>欠费人次（人）</div>
      </div>
      <div class="box2">
        <div class="fz-28">{{orderNum}}</div>
        <div>欠费订单数（单）</div>
      </div>
      <div class="box3">
        <div class="fz-28">{{debtAmt}}</div>
        <div>欠费金额（元）</div>
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}"
      style="width: 100%"
      class="table"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
      tooltip-effect="dark"
      >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="code" label="姓名">
        <template slot-scope="scope">
          {{scope.row.debtorsName}}
        </template>
      </el-table-column>
      <el-table-column prop="time" label="手机号">
        <template slot-scope="scope">
          {{scope.row.debtorsPhone}}
        </template>
      </el-table-column>
      <el-table-column prop="operateDate" label="收费日期">
      </el-table-column>
      <el-table-column prop="receivableAmt" label="总金额">
      </el-table-column>
      <el-table-column prop="actualReceivableAmt" label="应收金额">
      </el-table-column>
      <el-table-column prop="debtAmt" label="欠收金额">
      </el-table-column>
      <el-table-column prop="operator" label="收费员">
      </el-table-column>
      <el-table-column prop="platForm" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="toDetail(scope.row)">详情</el-button>
          <el-button type="text" size="small" @click="payment(scope.row)">立即付款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="tableData.length > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.currentPage"
        :page-sizes="pageSizes"
        :page-size.sync="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <pay-dialog
      :amount="serverTotal" 
      :orderId="orderIds" 
      :pay-type.sync="payType" 
      @complated="complate" 
      :debtorInfo="{}" 
      :visible.sync="dialogVisible"
      @close="dialogClose"
      :recordVersion="recordVersion"
    ></pay-dialog>
  </div>
</template>

<script>
import { pageSizes,pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize.js';
import { startDateYear } from '@/utils/filter';
import payDialog from '../pay/index.vue';
import { log } from 'util';
import setUrl from '@/mixins/setUrl';

export default {
  name: 'sale-drug',
  mixins: [ pageSize, setUrl ],
  components: { payDialog },
  data() {
    return {
      pageSizes: pageSizes,
      pickerOptions:pickerOptions,
      checkNum: 0,
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
        patient: '',
      },
      debtAmt: '',
      patientNum: '',
      orderNum: '',
      serverTotal: '', // 付款金额
      dialogVisible: false,
      payType: '', // 支付方式
      orderIds: '',
      multipleSelection: '',
      mergeTotal: '',
      recordVersion: '', // 订单版本
    };
  },

  methods: {
    // 获取列表信息
    filterChange() {
      this.query.currentPage = 1,
      this.queryChangeHandle();
      this.getTableData();
    },
    // 获取列表信息
    getTableData() {
      if (this.time) {
          this.query.startTime = this.time[0];
          this.query.endTime = this.time[1];
      } else {
          this.query.startTime = '';
          this.query.endTime = '';
      }
      this.$api.feeDispense.getDebt(this.query).then((res) => {
        this.tableData = res.order;
        this.debtAmt = res.debtAmt;
        this.patientNum = res.patientNum;
        this.orderNum = res.orderNum;
        this.total = res.totalSize;
      })
    },
    // 药品名称检索
    querySearchAsync(queryString, cb) {
      this.$api.drugControl.drugsNameList({
        drugName: this.query.drugName
      }).then((res) => {
        let drugNameList = [];
        drugNameList = res.drugList.map((item) => ({ value: item.drugName }));
        cb(drugNameList);
      })
    },
    // 选择药品名称
    handleSelect(item) {
      this.query.drugName = item.value;
    },
      // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.currentPage = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(value) {
      this.queryChangeHandle();
      this.getTableData();
    },
    toDetail(item) {
      this.$router.push({name: 'arrearsDetail', query: {id: item.id}});
    },
    payment(item) {
      this.orderIds = item.id;
      this.serverTotal  = item.debtAmt;
      this.recordVersion = item.recordVersion;
      this.payType = 'onePay';
      this.dialogVisible = true;
    },
    complate() {
      this.dialogVisible = false;
      this.getTableData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id);
      this.mergeTotal = val.reduce((a, b) => {
        return a + Number(b.debtAmt);
      }, 0);
    },
    mergePay() {
      if(this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择一个以上的欠费在进行合并付款',
        })
        return;
      }
      this.payType = 'morePay';
      this.serverTotal = this.mergeTotal;
      this.orderIds = this.multipleSelection.join(',');
      this.dialogVisible = true;
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        time: this.time,
        patient: this.query.patient,
        currentPage: this.query.currentPage,
      })
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.time = queryUrl.time ? queryUrl.time : startDateYear();
      this.query.patient = queryUrl.patient ? queryUrl.patient : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
    },
    dialogClose() {
      this.getTableData();
    }
  },
  mounted() {
    this.initQuery();
    this.getTableData();
  },
}
</script>

<style lang="scss" scoped>
.flex-div {
  display: flex;
  justify-content: space-between;
}
.flex-div .box1, .flex-div .box2,.flex-div .box3 {
  text-align: center;
  border-radius:4px;
  line-height: 1.5;
  color: #fff;
  width: 32%;
  padding: 28px 0;
}
.box1 {
  background: #89A6E6;
}
.box2 {
  background: #E3CD55;
}
.box3 {
  background: #A4D755;
}
.fz-28 {
  font-size: 28px;
}
.table {
  margin-top: 38px;
}
</style>


